import { render, staticRenderFns } from "./StopKillingAndReleaseAnimals.vue?vue&type=template&id=edec547a&"
import script from "./StopKillingAndReleaseAnimals.vue?vue&type=script&lang=js&"
export * from "./StopKillingAndReleaseAnimals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports